'use strict'


const heroGovernorsGreeting = {

  $layerFront: null,

  init(){

    this.$layerFront = document.querySelector('.governors-greeting-hero__layer-front .scroll-text');

    //jos elementtiä ei löydy, lisätään scroll-eventti
    if(!this.$layerFront) return;

    document.addEventListener('scroll', () => {

      let value = window.scrollY;

            // Liikutetaan tekstiä ylöspäin (mitä isompi luku, sitä nopeampi liike)
      this.$layerFront.style.transform = 'translateY(-' + value * 0.5 + 'px)';

            // Lasketaan läpinäkyvyys: se vähenee skrollatessa
            // 1 on täysin näkyvä, 0 on näkymätön
      this.$layerFront.style.opacity = 1 - (value / 500);
    }, {
      passive: true
    });
  }
};

module.exports = heroGovernorsGreeting;
